import React from "react";
import { NavLinkWrapper, LinkText } from "./styled";
import { useThemeUI } from "theme-ui";
import { Link, useLocation } from "react-router-dom";

interface NavLinkProps {
  link?: string;
  icon?: React.ComponentType<any>;
  label?: string;
  target?: string;
  onClick?: () => void;
  badge?: number | null;
  /** Sub-paths that have their own nav link, so this one stays unhighlighted there. */
  exclude?: string[];
}

const NavLink: React.FC<NavLinkProps> = ({ link, icon: Icon, label, target, onClick, badge, exclude }) => {
  const themeContext = useThemeUI();
  const { theme } = themeContext;
  const pathname = useLocation().pathname
  const active = !!link && pathname.startsWith(link) && !(exclude ?? []).some((p) => pathname.startsWith(p));

  return (    
    <NavLinkWrapper theme={theme} $active={active}>
      {link &&
        <Link className="link" to={link} target={target}>
          {Icon && <Icon fill={active ? theme?.colors?.white : "#BFBFBF"} width={"18px"} height={"auto"} mr={"8px"} />}
          <LinkText theme={theme} $active={active}>{label}</LinkText>
          {badge != null && badge > 0 && (
            <span style={{
              backgroundColor: "#E53E3E",
              color: "#fff",
              borderRadius: "10px",
              padding: "1px 6px",
              fontSize: "11px",
              fontWeight: 600,
              fontFamily: "Rubik",
              lineHeight: "16px",
              marginLeft: "auto",
              minWidth: "20px",
              textAlign: "center",
            }}>{badge > 99 ? "99+" : badge}</span>
          )}
        </Link>
      }
      {!link &&
        <span className="link" onClick={onClick}>
          {Icon && <Icon fill={theme?.colors?.base_100} width={"20px"} height={"23.33px"} mr={"8px"} />}
          <LinkText theme={theme}>{label}</LinkText>
        </span>
      }
    </NavLinkWrapper>    
  );
};

export default NavLink;
